import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { propType } from 'graphql-anywhere'

import { SCREEN_SIZE_BREAKPOINTS, APP_PADDING } from '../../constants'
import CATEGORY_COMPONENT_ITEM_FRAGMENT from '../../../graphql/fragments/category.gql'
import CategoryNavTabs from './category-navigation-tabs'
import CategoryNavSelector from './category-navigation-selector'
import { useScreenWidth } from '../../hooks/use-screen-width'

const SELECT_VALUE_KEY = 'name'

const CategoryNavigation = ({
  categoryItems,
  selectedCategory
}) => {
  const screenWidth = useScreenWidth()
  const [totalTabWidths, setTotalTabWidths] = useState(0)

  // eslint-disable-next-line
  const getNavMarginOffset = () => {
    /**
     * Ideally, these APP_PADDING values need to correspond
     * to the CSS app min values in `src/_variables.css` in
     * order to accurately determine which component to render.
     */
    if (screenWidth >= SCREEN_SIZE_BREAKPOINTS.MIN_768) {
      return APP_PADDING.MIN_768 * 2
    } if (screenWidth >= SCREEN_SIZE_BREAKPOINTS.MIN_480) {
      return APP_PADDING.MIN_480 * 2
    }
    return APP_PADDING.DEFAULT * 2
  }

  const navMarginOffset = getNavMarginOffset()
  const shouldRenderSelector = (screenWidth - navMarginOffset) < totalTabWidths

  return (
    <>
      {
        shouldRenderSelector ? (
          // Render categories as a dropdown on small screen
          <CategoryNavSelector
            categoryItems={categoryItems}
            selectedCategory={selectedCategory}
            selectKeyValue={SELECT_VALUE_KEY}
          />
        ) : (
          // Render categories as tabs on large screen
          <CategoryNavTabs
            categoryItems={categoryItems}
            selectedCategory={selectedCategory}
            onTotalTabWidths={(widths) => setTotalTabWidths(widths)}
            selectKeyValue={SELECT_VALUE_KEY}
          />
        )
      }
    </>
  )
}

CategoryNavigation.propTypes = {
  categoryItems: PropTypes.arrayOf(propType(CATEGORY_COMPONENT_ITEM_FRAGMENT)).isRequired,
  selectedCategory: propType(CATEGORY_COMPONENT_ITEM_FRAGMENT).isRequired
}

export default CategoryNavigation
